import React from 'react';
import './TextInput.css';

const TextInput = ({
  label,
  value,
  onChange,
  placeholder = '',
  type = 'text',
  required = false,
  error = null
}) => {
  return (
    <div className="text-input">
      {label && (
        <label className="text-input__label">
          {label}
          {required && <span className="text-input__required">*</span>}
        </label>
      )}
      <input
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className={`text-input__field ${error ? 'text-input__field--error' : ''}`}
      />
      {error && <span className="text-input__error">{error}</span>}
    </div>
  );
};

export default TextInput;
